export default {
  modalHeader: {
    id: 'seller_flash_sales_modal_header',
    defaultMessage: 'Deals',
  },
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
} as const
